module.exports = __webpack_public_path__ + "static/media/business.24afe61e.png";